var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{attrs:{"two-line":""}},[_c('SubHeader',{attrs:{"name":_vm.title}}),_c('DraggableContent',{attrs:{"items":_vm.items},on:{"content-array":_vm.updateContentList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }